import { render, staticRenderFns } from "./coaView.vue?vue&type=template&id=0ae327c3&scoped=true&"
import script from "./coaView.vue?vue&type=script&lang=js&"
export * from "./coaView.vue?vue&type=script&lang=js&"
import style0 from "./coaView.vue?vue&type=style&index=0&id=0ae327c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae327c3",
  null
  
)

export default component.exports